import es from './es';

const resources = { es };

export default resources;
